export default __webpack_public_path__ + "static/chip_art-05@2x_1-512e35823cec989a871fabf00ab7972c.jpeg";